<template>
    <div>
        <!-- Grille des tables (cartes) -->
        <div v-if="showList">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <div class="d-flex align-items-center">
                    <!-- <button class="btn fs-sm btn-dark px-4 rounded-8 fw-medium btn-dark-index me-2" @click="showModalTest">
                        Ajouter tables
                    </button> -->
                </div>
                <div class="d-flex align-items-center">
                    <button
                        class="btn fs-sm btn-outline-primary px-4 rounded-8 fw-medium btn-dark-index me-2"
                        @click="confirmExportPdf"
                        :disabled="exportLoading"
                    >
                        <span v-if="!exportLoading"><i class="bi bi-download me-1"></i> Export QR</span>
                        <span v-else>
                            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Téléchargement…
                        </span>
                    </button>
                    <label class="mb-0 me-2">Tables par ligne&nbsp;:</label>
                    <select v-model="gridColumns" class="form-select me-2 select-grid-columns">
                        <option v-for="n in [2, 3]" :key="n" :value="n">{{ n }}</option>
                    </select>
                    <div class="form-check form-switch mb-0">
                        <input class="form-check-input" type="checkbox" id="showQrCodeSwitch" v-model="showQrCode" />
                        <label class="form-check-label ms-2" for="showQrCodeSwitch"> Afficher QR code </label>
                    </div>
                </div>
            </div>
            <div v-if="loading" class="d-flex align-items-center gap-2">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Chargement…
            </div>
            <div v-if="isLoadingMore" class="d-flex align-items-center gap-2 mt-2">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Chargement de plus de tables…
            </div>
            <div
                v-if="message"
                class="alert alert-success d-flex align-items-center my-2 p-2"
                role="alert"
                style="padding: 7px !important; width: 100% !important"
            >
                <i class="bi bi-check-circle-fill me-2"></i>
                <span>{{ message }}</span>
            </div>
            <transition-group
                name="card-move"
                tag="div"
                class="table-card-grid"
                :style="{ gridTemplateColumns: `repeat(${gridColumns}, 1fr)`, maxHeight: '60vh', overflowY: 'auto' }"
                @dragover.prevent
            >
                <div
                    class="table-card position-relative"
                    v-for="(item, idx) in items"
                    :key="item.id"
                    draggable="true"
                    @dragstart="onDragStart(idx)"
                    @dragenter="onDragEnter(idx)"
                    @dragover.prevent
                    @drop="onDrop(idx)"
                    :class="{ dragging: idx === dragIdx, over: idx === overIdx }"
                    @dblclick="editTableName(item)"
                >
                    <button
                        class="btn btn-secondary btn-sm position-absolute"
                        style="left: 10px; top: 10px; z-index: 5"
                        @click.stop="copyFrontLink(item)"
                        title="Copier le lien de la table"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="white" viewBox="0 0 24 24">
                            <path
                                d="M16 2H8c-1.1 0-2 .9-2 2v2H4v16h16V6h-2V4c0-1.1-.9-2-2-2zm0 2v2H8V4h8zM6 8h12v12H6V8zm5.29 5.71 4.58-4.59-1.42-1.41L11 11.17l-1.46-1.46-1.42 1.41L11 14.12z"
                            />
                        </svg>
                    </button>

                    <button
                        class="btn btn-danger btn-sm position-absolute"
                        style="right: 10px; top: 10px; z-index: 5"
                        @click.stop="confirmDeleteTable(item)"
                        title="Supprimer la table"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
                            <path
                                fill="#fff"
                                d="M6.25 7.25a.75.75 0 0 1 .75.75V19a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a.75.75 0 0 1 1.5 0v11a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 4.5 19V8a.75.75 0 0 1 .75-.75Zm3.75 1.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Zm3 0a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75ZM9.25 4A2.25 2.25 0 0 1 11.5 1.75h1A2.25 2.25 0 0 1 14.75 4v.25h3a.75.75 0 0 1 0 1.5H6.25a.75.75 0 0 1 0-1.5h3V4Zm1.5 0V4.25h2V4a.75.75 0 0 0-.75-.75h-1A.75.75 0 0 0 10.75 4Z"
                            />
                        </svg>
                    </button>
                    <div v-if="editingId !== item.id" class="card-label">{{ item.name }}</div>
                    <input
                        v-if="editingId === item.id"
                        v-model="item.name"
                        @blur="saveTableName(item)"
                        @keyup.enter="saveTableName(item)"
                        class="form-control"
                        autofocus
                    />
                    <div v-if="showQrCode && item.qr_code_url" class="mt-2">
                        <img :src="item.qr_code_url" alt="QR Code" style="max-width: 80px; max-height: 80px" />
                    </div>
                </div>
            </transition-group>

            <button v-if="orderChanged" class="btn btn-success mt-3 save-order-sticky" @click="saveOrder">
                Sauvegarder l'ordre
            </button>
        </div>

        <!-- Modal d'ajout -->
        <modal name="add-table-modal" :adaptive="true">
            <div class="modal-header">
                <h3>Nombre de tables à ajouter</h3>
                <button class="close-btn" @click="closeModal">&times;</button>
            </div>
            <div class="modal-body">
                <input
                    type="number"
                    v-model="number_of_tables"
                    min="1"
                    placeholder="Nombre de tables à ajouter"
                    class="form-control h-40"
                />
            </div>
            <div class="modal-footer">
                <button @click="closeModal" class="btn fs-sm btn-outline-dark px-4 rounded-8 fw-medium">Annuler</button>
                <button @click="save" class="btn fs-sm btn-dark px-4 rounded-8 fw-medium btn-dark-index">Enregistrer</button>
            </div>
        </modal>

        <!-- Modal export QR code -->
        <modal name="export-qr-modal" style="">
            <div class="modal-header">
                <h3 style="margin: 0; font-size: 1.2rem">Sélectionner les tables à exporter</h3>
                <button class="close-btn" @click="closeExportModal">&times;</button>
            </div>
            <div style="overflow-y: auto; padding: 0.5rem 0.5rem 0 0.5rem">
                <div v-for="table in items" :key="table.id" class="form-check mb-2 d-flex align-items-center">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :id="'export-table-' + table.id"
                        v-model="exportSelected"
                        :value="table.uuid"
                        style="margin-right: 8px"
                    />
                    <label class="form-check-label ms-1" :for="'export-table-' + table.id" style="font-weight: 500">
                        {{ table.name }}
                        <small class="text-muted" style="font-size: 0.82em">({{ table.uuid }})</small>
                    </label>
                </div>
                <div v-if="!items.length" class="text-muted py-3 text-center">Aucune table disponible.</div>
            </div>
            <div class="modal-footer d-flex justify-content-end gap-2" style="padding-top: 12px">
                <button @click="closeExportModal" class="btn btn-outline-dark px-4 rounded-8 fw-medium">Annuler</button>
                <button @click="confirmExportPdf" class="btn btn-success px-4 rounded-8 fw-medium">
                    <i class="bi bi-download me-1"></i>
                    Exporter la sélection ({{ exportSelected.length }})
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
import ApiManager from '../Api/ApiManagerFood.js'

export default {
    data() {
        return {
            editingId: null,
            showModal: false,
            number_of_tables: 1,
            showList: false,
            items: [],
            loading: false,
            dragIdx: null,
            overIdx: null,
            orderChanged: false,
            originalItems: [],
            gridColumns: 3,
            showQrCode: true,
            message: null,
            exportLoading: false,
            exportSelected: [],
            currentPage: 1,
            lastPage: 1,
            perPage: 10,
            isLoadingMore: false,
            scrollContainer: null,
        }
    },
    methods: {
        showModalTest() {
            this.number_of_tables = 1
            this.$modal.show('add-table-modal')
            this.showModal = true
        },
        closeModal() {
            this.$modal.hide('add-table-modal')
            this.showModal = false
        },
        async save() {
            try {
                const payload = { number_of_tables: this.number_of_tables }
                await ApiManager.addTablesByNumbers(payload)
                this.message =
                    "Le(s) QR code(s) sera(ont) généré(s) automatiquement via la file d'attente. Merci de patienter, il(s) sera(ont) normalement disponible entre 5 et 10 secondes."
                this.$toast.success(this.$t('food.tables.added_success'))
                if (this.showList) {
                    await this.fetchTables()
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
            this.closeModal()
        },
        editTableName(item) {
            this.editingId = item.id
        },
        async saveTableName(item) {
            this.editingId = null
            const originalName = this.originalItems.find((i) => i.id === item.id).name
            try {
                await ApiManager.updateTable(item.id, { name: item.name })
                this.$toast.success('Table name updated successfully')
            } catch (error) {
                this.$toast.error(error.response.data.message)
                item.name = originalName
                if (error.response.data.errors.name) {
                    this.$toast.error(error.response.data.errors.name[0])
                }
                console.error('Error updating table name:', error)
            }
        },
        async fetchTables(page = 1, append = false) {
            // If appending and we're already loading more data, return
            if (append && (this.isLoadingMore || this.currentPage >= this.lastPage)) {
                return
            }

            if (!append) {
                this.showList = true
                this.loading = true
                this.items = []
            } else {
                this.isLoadingMore = true
            }

            try {
                const data = await ApiManager.fetchTables(page, this.perPage)
                console.log('data ddds', data?.data || data?.data?.data || [])

                const newItems = data?.data?.data || []
                this.lastPage = data?.data?.last_page || 1
                this.currentPage = data?.data?.current_page || 1

                if (append) {
                    // Append new items to existing ones
                    this.items = [...this.items, ...newItems]
                } else {
                    // Replace items
                    this.items = newItems
                }

                this.originalItems = JSON.parse(JSON.stringify(this.items)) // Deep copy for change detection
                this.orderChanged = false
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }

            this.loading = false
            this.isLoadingMore = false
        },
        // Drag & Drop Handlers
        onDragStart(idx) {
            this.dragIdx = idx
        },
        onDragEnter(idx) {
            this.overIdx = idx
        },
        onDrop(idx) {
            if (this.dragIdx === null || this.dragIdx === idx) {
                this.dragIdx = null
                this.overIdx = null
                return
            }
            const items = [...this.items]
            const moved = items.splice(this.dragIdx, 1)[0]
            items.splice(idx, 0, moved)
            this.items = items
            this.dragIdx = null
            this.overIdx = null
            // Compare to original to detect change
            this.orderChanged =
                JSON.stringify(this.items.map((i) => i.id)) !== JSON.stringify(this.originalItems.map((i) => i.id))
        },
        async saveOrder() {
            try {
                // Compose array: [{id: .., index: ..}, ...]
                const order = this.items.map((item, i) => ({ id: item.id, index: i + 1 }))
                await ApiManager.changeFoodTableOrder({ items: order })
                this.originalItems = JSON.parse(JSON.stringify(this.items))
                this.orderChanged = false
            } catch (e) {
                console.error('Failed to save order', e)
            }
        },
        exportPdf() {
            // Récupérer les uuids visibles si tu veux exporter seulement les sélectionnés :
            // const uuids = this.items.map(item => item.uuid);

            // Pour exporter tout le set courant :
            const params = new URLSearchParams()
            params.append('per_row', this.gridColumns)

            // Optionnel: ajouter l'établissement si tu veux
            // params.append('establishment_id', ...);

            // Ouvre le PDF dans un nouvel onglet
            window.open(`tables/export-qr-pdf?${params.toString()}`, '_blank')
        },
        openExportModal() {
            // Par défaut, toutes les tables sont sélectionnées
            this.exportSelected = this.items.map((item) => item.uuid)
            this.$modal.show('export-qr-modal')
        },
        closeExportModal() {
            this.$modal.hide('export-qr-modal')
        },
        async confirmExportPdf() {
            if (this.exportLoading) return
            this.exportLoading = true
            this.exportSelected = this.items.map((item) => item.uuid)

            const params = new URLSearchParams()
            params.append('per_row', this.gridColumns)
            this.exportSelected.forEach((uuid) => params.append('uuids[]', uuid))

            const url = `/back-office/food/tables/export-qr-pdf?${params.toString()}`

            try {
                const response = await fetch(url, {
                    method: 'GET',
                })
                if (!response.ok) throw new Error('Erreur lors du téléchargement du PDF.')

                const blob = await response.blob()
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = 'tables-qr.pdf'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(link.href)
            } catch (e) {
                this.$$$toast?.error?.('Erreur lors du téléchargement du PDF.')
                console.error(e)
            } finally {
                this.exportLoading = false
                this.closeExportModal()
            }
        },

        confirmExportPdfOld() {
            this.exportLoading = true
            this.exportSelected = this.items.map((item) => item.uuid)

            /*
            if (!this.exportSelected.length) {
                this.$toast.error(this.$t('food.tables.select_at_least_one'))
                return
            }
            */

            const params = new URLSearchParams()
            params.append('per_row', this.gridColumns)
            this.exportSelected.forEach((uuid) => params.append('uuids[]', uuid))

            window.open(`tables/export-qr-pdf?${params.toString()}`, '_blank')
            this.closeExportModal()
        },

        confirmDeleteTable(item) {
            if (confirm(`Supprimer la table "${item.name}" ? Cette action est irréversible.`)) {
                this.deleteTable(item)
            }
        },

        async deleteTable(item) {
            try {
                await ApiManager.deleteTable(item.uuid)
                this.$toast.success(this.$t('food.tables.deleted_success'))
                this.fetchTables()
            } catch (e) {
                this.$toast.error(this.$t('common.delete_error'))
                console.error(e)
            }
        },

        copyFrontLink(item) {
            if (!item.url_front_link) {
                this.$toast?.error?.('Lien indisponible pour cette table.')
                return
            }

            navigator.clipboard
                .writeText(item.url_front_link)
                .then(() => {
                    this.$toast?.success?.('Lien copié dans le presse-papier.')
                })
                .catch((err) => {
                    this.$toast?.error?.('Impossible de copier le lien.')
                })
        },

        handleScroll(event) {
            const { scrollTop, scrollHeight, clientHeight } = event.target
            // Check if user has scrolled to the bottom (with a small threshold)
            if (scrollHeight - scrollTop <= clientHeight + 10) {
                // Load more data if we haven't reached the last page
                if (this.currentPage < this.lastPage && !this.isLoadingMore) {
                    this.fetchTables(this.currentPage + 1, true)
                }
            }
        },
    },

    watch: {
        showQrCode(val) {
            localStorage.setItem('showQrCode', val)
        },
        gridColumns(val) {
            localStorage.setItem('gridColumns', val)
        },
    },

    mounted() {
        // Restore showQrCode from localStorage
        const showQrCodeLS = localStorage.getItem('showQrCode')
        if (showQrCodeLS !== null) {
            this.showQrCode = showQrCodeLS === 'true'
        }

        // Restore gridColumns from localStorage
        const gridColumnsLS = localStorage.getItem('gridColumns')
        if (gridColumnsLS !== null && [2, 3, 4, 5].includes(Number(gridColumnsLS))) {
            this.gridColumns = Number(gridColumnsLS)
        }

        this.showList = true
        this.fetchTables()

        // Add scroll event listener for infinite scrolling
        this.$nextTick(() => {
            const grid = document.querySelector('.table-card-grid')
            if (grid) {
                this.scrollContainer = grid
                this.scrollContainer.addEventListener('scroll', this.handleScroll)
            }
        })
    },
    beforeDestroy() {
        // Remove scroll event listener when component is destroyed
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener('scroll', this.handleScroll)
        }
    },
}
</script>

<style scoped>
.table-card-grid {
    display: grid;
    gap: 18px;
}
@media (max-width: 900px) {
    .table-card-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}
@media (max-width: 600px) {
    .table-card-grid {
        grid-template-columns: 1fr;
    }
}
.table-card {
    background: #fff;
    border: 2px solid #e8e8e8;
    border-radius: 10px;
    padding: 24px 12px 12px 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition:
        box-shadow 0.18s,
        border-color 0.2s,
        transform 0.18s,
        background 0.23s;
    box-shadow: 0 2px 12px rgba(34, 34, 34, 0.03);
    cursor: grab;
    position: relative;
    min-height: 110px;
    user-select: none;
}
.table-card:active {
    cursor: grabbing;
}
.table-card.dragging {
    opacity: 0.7;
    border-color: #7d2dbd;
    box-shadow:
        0 8px 30px 0 rgba(45, 139, 99, 0.18),
        0 2px 12px rgba(34, 34, 34, 0.1);
    transform: scale(1.04) rotate(-2deg);
    z-index: 2;
}
.table-card.over {
    border-color: #16a085;
    background: linear-gradient(90deg, #f0fff5 60%, #eafff2 100%);
    box-shadow: 0 6px 18px 0 rgba(22, 160, 133, 0.12);
    animation: cardRipple 0.3s;
    position: relative;
}
@keyframes cardRipple {
    from {
        box-shadow: 0 0 0 0 #16a08555;
    }
    to {
        box-shadow: 0 8px 40px 10px #16a08522;
    }
}
.card-label {
    font-size: 1.3rem;
    font-weight: 600;
}
.save-order-sticky {
    position: sticky;
    bottom: 12px;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 50;
    box-shadow: 0 3px 20px #2d8b6377;
    border-radius: 8px;
    font-weight: 600;
    width: max-content;
    min-width: 200px;
    display: block;
}
.card-move-move {
    transition: transform 0.25s cubic-bezier(0.43, 0.13, 0.23, 0.96);
}
.close-btn {
    background: none;
    border: none;
    font-size: 2rem;
    color: #888;
    cursor: pointer;
}
.close-btn:hover {
    color: #e74c3c;
}
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
}
.cancel-btn,
.save-btn {
    padding: 8px 18px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
}

.form-switch {
    height: 1.1em !important;
}

.loader {
    border: 3px solid #e0e0e0;
    border-top: 3px solid #7d2dbd;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    animation: spin 0.9s linear infinite;
    display: inline-block;
    margin-right: 0.5rem;
}
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.select-grid-columns {
    width: 70px;
    min-height: 38px;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
</style>
